// extracted by mini-css-extract-plugin
export default {"myfirstcpnblog":"ec0a6f4641a2b31d45fa"};